import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CircularProgress,
  DialogActions,
  DialogContent,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import moment from "moment";
import JoditEditorExample from "../../../helpers/JoditEditorExample";
import FullScreenModal from "../../../components/Modal/FullScreenModal";
import ViewParticipants from "./ViewParticipants";
import { IUser } from "../../../store/User/type";
import Modal from "../../../components/Modal/Modal";
import { SubmitButton } from "../../../components/buttons";
import BootStrapDialog from "../../../helpers/BootStrapDialog";
import BootstrapDialogTitle from "../../../helpers/BootstrapDialogTitle";
import Typography from "@mui/material/Typography";
import { StyledTableRow } from "helpers/CustomMenu";
import { Delete, Menu } from "@mui/icons-material";
import AddModal from "components/ActionTracking/AddModal";
import axios from "axios";

const Create = (props) => {
  const {
    setFiles,
    settings,
    // meetings,
    // setSelectedMeeting,
    setContent,
    content,
    GetEmployees,
    onSubmit,
    // selectedMeeting,
    resources,
    // meeting,
    systemSettings,
  } = props;
  const [upload, setUpload] = useState(false);
  const [template, setTemplate] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [viewParticipants, setView] = React.useState(false);
  const [viewComment, setViewComment] = useState(false);
  const [comment, setComment] = useState("");
  const [select, setSelect] = useState(false);
  const [addAction, setAddAction] = useState(false);
  const [type, setType] = useState("");
  const [info, setInfo] = useState({});
  const [activiesList, setActiviesList] = useState([]);
  const [filteredActivitiesList, setFilteredActivitiesList] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [meeting, setMeeting] = useState(null);
  const [selectedMeeting, setSelectedMeeting] = useState("");
  const mainBackground = systemSettings?.mainBackground;


  let history = useHistory();

  const activities = async () => {
    try {
      const response = await axios.get("api/task/list/notRelated");
      const data = response.data.data;
      setActiviesList(data);
    } catch (error) { }
  };
  useEffect(() => {
    activities();
  }, []);

  useEffect(() => {
    const fetchMeetings = async () => {
      try {
        const response = await axios.get(`api/meeting/datatable?status=${'completed'}&hasMinutes=false`);
        const data = response.data.data;
        setMeetings(data);
      } catch (error) {
        console.error("Error fetching meetings:", error);
      }
    };
    fetchMeetings();
  }, []);
  useEffect(() => {
    // Filter activities based on the selected meeting ID
    if (selectedMeeting) {
      const found = meetings.find((m) => m.id === selectedMeeting);
      if (found) {
        setMeeting(found);
      }
      const filtered = activiesList.filter(
        (activiesList) => activiesList.meetingId === selectedMeeting
      );
      setFilteredActivitiesList(filtered);
    } else {
      // setFilteredActivitiesList(activiesList); // Show all if no meeting is selected
      setFilteredActivitiesList(null); // Show null if no meeting is selected
    }
  }, [selectedMeeting, activiesList, meetings]);

  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb flex items-center">
          <li className="breadcrumb-item pageTitle">
            <Link
              to="/admin/minutes"
              className="text-white text-decoration-none"
            >
              Minutes /
            </Link>
          </li>
          <li
            className=" ml-1 breadcrumb-item active pageTitle"
            aria-current="page"
          >
            Create
          </li>
        </ol>
      </nav>
      <div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setSelect(true);
            // await onSubmit("");
          }}
        >
          <Card className="mt-4">
            <CardContent>
              {selectedMeeting ? (
                // Uncomment the next line for debugging outside JSX if needed
                <Card variant={"outlined"} className="mb-3">
                  <CardHeader
                    title={"Meeting details"}
                    titleTypographyProps={{ variant: "h6" }}
                    style={{ color: mainBackground }}
                  />
                  {!meeting ? (
                    <div className={"text-center p-5"}>
                      <CircularProgress />
                    </div>
                  )

                    : (

                      <CardContent>
                        <div className={"row mb-3"}>
                          <div className="col-md-6 mb-3">
                            <label
                              className="col-md-2 text-capitalize fw-bold mb-3"
                              style={{ display: "inline-block", width: "100px" }}
                            >
                              <b>Start: </b>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              value={moment(meeting?.start).format("DD/MM/yyyy hh:mm a")}
                              disabled
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label
                              className="col-md-2 text-capitalize fw-bold mb-3"
                              style={{ display: "inline-block", width: "100px" }}
                            >
                              <b>End: </b>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              value={moment(meeting?.end).format("DD/MM/yyyy hh:mm a")}
                              disabled
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label
                              className="col-md-2 text-capitalize fw-bold mb-3"
                              style={{ display: "inline-block", width: "100px" }}
                            >
                              <b>Name: </b>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              value={meeting?.name}
                              disabled
                            />
                          </div>
                          <div className="col-md-6 mb-3">
                            <label
                              className="col-md-2 text-capitalize fw-bold mb-3"
                              style={{ display: "inline-block", width: "100px" }}
                            >
                              <b>Venue: </b>
                            </label>
                            <input
                              className="form-control form-control-sm"
                              // value={meeting?.Room?.name}
                              value={meeting?.venue ? meeting?.venue : meeting?.Room?.name}
                              disabled
                            />
                          </div>
                        </div>
                        <div className={"row "}>
                          <div className="col-md-2 ">
                            <label
                              className="col-md-2 text-capitalize fw-bold mb-3"
                              style={{ display: "inline-block", width: "100px" }}
                            >
                              <b>Participant: </b>
                            </label>
                            <span className="text-center fw-bold fs-6">
                              {meeting?.MeetingParticipants?.length}
                            </span>
                          </div>
                          <div className="col-md-4 ">
                            {meeting.length && (
                              <button
                                type="button"
                                onClick={() => setView(true)}
                                style={{ color: mainBackground }}
                              >
                                View Participants
                              </button>
                            )}
                          </div>
                        </div>
                      </CardContent>
                    )}
                </Card>
              ) : (
                <div
                  className="grid grid-cols-4 gap-2 mb-3 items-center"
                  style={{ width: "30%" }}
                >
                  <label className="col-form-label fw-bold text-capitalize col-span-1">
                    Meeting
                  </label>
                  <select
                    // value={reminder}
                    id="reminder"
                    // className="form-select form-select-sm"
                    className="col-span-3 form-control px-3 py-3 border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    onChange={(e) => { setSelectedMeeting(e.target.value) }

                    }
                  >
                    <option>select</option>
                    {meetings
                      ?.filter(
                        (v) => v?.status === "completed" && !v?.hasMinutes // Meetings that are fetched
                      )
                      .map((item) => (
                        <option value={item.id}>{item?.name}</option>
                      ))}
                  </select>
                </div>
              )}

              <Card variant={"outlined"} className="overflow-auto">
                <CardHeader
                  title={"Write Minutes"}
                  titleTypographyProps={{ variant: "h6" }}
                  action={
                    <div>
                      <Button
                        onClick={() => {
                          setTemplate(false);
                          setUpload(true);
                        }}
                        className={"me-2"}
                        style={{ color: mainBackground }}
                      >
                        <i className="fa fa-cloud-upload-alt me-1 " /> Upload
                        File
                      </Button>
                      <Button
                        startIcon={<Menu />}
                        onClick={() => setAddAction(true)}
                        style={{ color: mainBackground }}
                      >
                        Add Activity
                      </Button>
                      {/* <Button
                        onClick={() => {
                          setTemplate(true);
                          setUpload(false);
                        }}>
                        <i className="fa fa-plus fa-md me-1 " /> Use Template
                      </Button> */}
                    </div>
                  }
                />
                <CardContent>
                  {upload && (
                    <TextField
                      type="file"
                      id={"file-id-1"}
                      required={upload}
                      className="form-control form-control-md col-6 me-2"
                      inputProps={{ accept: "application/pdf" }}
                      onChange={(e) => {
                        setFiles(e.currentTarget.files);
                      }}
                    // style={{ display: "none" }}
                    />
                  )}

                  {template && (
                    <>
                      <div className={"mb-4"}>
                        <JoditEditorExample
                          htmlContent={content}
                          onBlur={(str) => {
                            setContent(str.target.value);
                          }}
                        />
                      </div>
                    </>
                  )}
                  {activiesList?.length ? (
                    <>
                      {/* add actions */}
                      <Typography>Actions</Typography>

                      {/* list of actions */}
                      <TableContainer>
                        <Table size={"small"}>
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Name</TableCell>
                              <TableCell>Start date</TableCell>
                              <TableCell>End date</TableCell>
                              <TableCell>Meetinng</TableCell>
                              <TableCell>Description</TableCell>
                              <TableCell>Action</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredActivitiesList?.map((item, index) => (
                              <StyledTableRow>
                                <TableCell>#{index + 1}</TableCell>
                                <TableCell>{item?.name}</TableCell>
                                <TableCell>
                                  {item?.startDate
                                    ? new Date(
                                      item.startDate
                                    ).toLocaleDateString("en-CA")
                                    : "N/A"}
                                </TableCell>
                                <TableCell>
                                  {item?.endDate
                                    ? new Date(item.endDate).toLocaleDateString(
                                      "en-CA"
                                    )
                                    : "N/A"}
                                </TableCell>
                                <TableCell>{meeting?.name}</TableCell>
                                <TableCell>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.description,
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    color={"error"}
                                    onClick={() => {
                                      activiesList.splice(index, 1);
                                      setActiviesList([...activiesList]);
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </TableCell>
                              </StyledTableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </CardContent>
              </Card>
            </CardContent>
            <CardActions className={"float-end"}>
              <Button
                color={"error"}
                variant="contained"
                size="small"
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>
              {loading ? (
                <CircularProgress />
              ) : upload ? (
                <SubmitButton
                  name={"Add"}
                  confirm={select && upload}
                  handleAction={() => {
                    const info = {
                      meetingId: selectedMeeting,
                      content,
                      listOfAction: activiesList,
                      files: upload ? Array.from(upload) : [],
                    };
                    onSubmit(info);
                  }}
                  setConfirm={setSelect}
                />
              ) : (

                <Button
                  type={"submit"}
                  color={"success"}
                  variant={"contained"}
                  size={"small"}
                  style={{ backgroundColor: mainBackground }}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelect(true);
                    const info = {
                      meetingId: selectedMeeting,
                      content,
                      listOfAction: activiesList,
                      files: upload ? Array.from(upload) : [],
                    };
                    onSubmit(info);
                  }}
                >
                  Add
                </Button>
              )}
            </CardActions>
          </Card>
        </form>
      </div>
      <BootStrapDialog
        fullWidth={true}
        maxWidth={"xs"}
        onClose={() => setSelect(false)}
        open={select && !upload}
      >
        <form
          action=""
          onSubmit={async (event) => {
            event.preventDefault();
            setLoading(true);
            await onSubmit("");
            setLoading(false);
            // }
          }}
        >
          <BootstrapDialogTitle
            id={"add-signature"}
            onClose={() => setSelect(false)}
          >
            create minutes
          </BootstrapDialogTitle>
          <DialogContent>
            Are you sure you want to submit minutes?
          </DialogContent>
          <DialogActions>
            {loading ? (
              <CircularProgress />
            ) : (
              <>
                <Button color={"error"} onClick={() => setSelect(false)}>
                  Cancel
                </Button>
                <Button type={"submit"}>Add Minutes</Button>
              </>
            )}
          </DialogActions>
        </form>
      </BootStrapDialog>

      <Modal setSelect={setViewComment} select={viewComment} title={"Comment"}>
        <div className="p-3">{comment}</div>
      </Modal>
      <FullScreenModal setSelect={setView} select={viewParticipants}>
        <ViewParticipants
          participants={meeting?.length ? meeting?.MeetingParticipants : []}
          setComment={setComment}
          setViewComment={setViewComment}
          systemSettings={systemSettings}
        />
      </FullScreenModal>
      {/* add action to a minutes */}
      <AddModal
        setType={setType}
        setInfo={setInfo}
        resources={resources}
        GetEmployees={GetEmployees}
        info={{ ...info, meetingId: selectedMeeting }}
        type={type}
        settings={settings}
        setSelect={setAddAction}
        select={addAction}
        loading={loading}
        selectedMeeting={selectedMeeting}
        needDirectSubmit={false}
        meeting={selectedMeeting}
        setListOfAction={setActiviesList}
        listOfAction={activiesList}
        systemSettings={systemSettings}
      />
    </div >
  );
};
export default Create;
